import React, { useMemo } from 'react';

// Components
import GroupSwitch from '../GroupSwitch';

// Utils
import { isDisabled } from '../../utils/card';
import { replaceStr } from '../../utils';

const FormButtons = ({ item, changeGroup }) => {
  const buttons = useMemo(
    () =>
      item.release_forms.map(
        ({ id, quantity, drugstore_price, online_price, pack_info, name }) => ({
          id,
          name: 'package',
          value: replaceStr(name, item.goods_name.name).replace(/^\s/g, ''),
          disabled: isDisabled({
            quantity,
            drugstore_price,
            online_price,
          }),
          pack_info,
        })
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [item]
  );

  return <GroupSwitch buttons={buttons} onSelect={changeGroup} />;
};

export default FormButtons;
